var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step",class:[
    _vm.step > _vm.number ? 'completed' : '',
    _vm.step == _vm.number ? 'active' : ''
],attrs:{"data-step":_vm.number}},[_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.number))]),_vm._v(" "+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }